<template>
  <div id="sidebar-category" class="col-xs-12 col-sm-12 col-md-12 col-lg-10">
        <div class="box_style_2 rightcontent" id="myAccount">
            <h2 class="inner">My Account</h2>
            <div class="col-md-6 col-sm-6 add_bottom_15" style="padding:0">
                <div class="wrapper_indent">
                    <div class="form-group">
                        <label>New Password</label>
                        <input class="form-control" name="new_password" v-model="new_password" type="password" placeholder="Enter New Password">
                    </div>
                    <div class="form-group">
                        <label>Confirm New Password</label>
                        <input class="form-control" name="confirm_new_password" v-model="confirm_new_password" type="password" placeholder="Confirm New Password">
                    </div>
                    <button type="submit" class="btn_1 green" @click.prevent="updatePassword">Update Password</button>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
  </div>  
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as render from '../utils/render'

export default {
    name: 'MyAccount',
    data() {
	  return {
		  new_password: '',
		  confirm_new_password: ''
	  }
    },

    methods: {
        updatePassword(){
		if(this.new_password == ''){
			this.$fire({
				html: "<b>Please Enter Password</b>",
				title: 'Error !!',
				type: "error",
				timer: 3000
			});
		}else if(this.confirm_new_password == ''){
			this.$fire({
				html: "<b>Please Enter Confirm Password</b>",
				title: 'Error !!',
				type: "error",
				timer: 3000
			});
		}else if(this.new_password != this.confirm_new_password){
			this.$fire({
				html: "<b>Password and confirm password not matched</b>",
				title: 'Error !!',
				type: "error",
				timer: 3000
			});
		}else{
			this.$store.dispatch('updatePassword',{
				change_password: this.new_password,
			}).then((response)=>{
				this.new_password = '';
				this.confirm_new_password = '';
				if(response.status == 1){
					this.$fire({
						title: response.message,
						type: "success",
						timer: 3000
					});
				}else{
					this.$fire({
						title: response.message,
						type: "warning",
						timer: 3000
					});
				}
			})
		} 
	 }, 
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumb_menu_list{
	height: 60px
}
.table>thead>tr>td{
	padding:3px;
}
.rightcontent{
    background: rgb(255, 255, 255);
    padding:30px 20px;
    margin-top: 1px;
    min-height: auto !important;
}

</style>
